import { render } from "./SearchCustomerForm.vue?vue&type=template&id=648a6880"
import script from "./SearchCustomerForm.vue?vue&type=script&lang=js"
export * from "./SearchCustomerForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__